module.exports = __webpack_public_path__ + "static/img/help2.d263136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/help2.png
// module id = R8IR
// module chunks = 1